module.exports = __webpack_public_path__ + "static/media/grid.c8dbfcfc.svg";